module.exports = __webpack_public_path__ + "img/favicon.e71a924.png";